//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function DragOverlayGroup({ draggedObject }) {
  let description = "( )"

  return <div className={myStyles.dragOverlyGeneral}>{description}</div>
}
